import {ZoneType} from "./zoneDeptRelation";

export class EncodedTag {

  secondField: string;

  productSerial: string;

  newEpc: string;

  selectedZone: ZoneType;

  date: number;

  constructor(secondField: string, productSerial: string, newEpc: string, selectedZone: ZoneType, date: number) {
    this.secondField = secondField;
    this.productSerial = productSerial;
    this.newEpc = newEpc;
    this.selectedZone = selectedZone;
    this.date = date;
  }
}



// WEBPACK FOOTER //
// ./src/models/EncodedTag.ts